import * as React from 'react';

interface CheckmarkProps {
    className?: string;
}

export const Checkmark: React.SFC<CheckmarkProps> = ({ className }) => (
    <svg 
        xmlns="http://www.w3.org/2000/svg" 
        width="23.461" 
        height="16.834" 
        viewBox="0 0 23.461 16.834"
        className={className}
    >
        <path 
            id="checkmark" 
            d="M25.218,9,12.006,22.212,6,16.207" 
            transform="translate(-3.879 -6.879)" 
            fill="none" 
            stroke="currentColor" 
            strokeLinecap="round" 
            strokeLinejoin="round" 
            strokeWidth="3"
        />
    </svg>
);



// WEBPACK FOOTER //
// ./src/components/common/Checkmark.tsx